export default __webpack_public_path__ + "static/media/canny-notification.dba4064a.svg";